import { Box } from '@mui/material';
import React, { ReactElement, ReactNode, useCallback, useState } from 'react';

export interface TruncateTextProps {
  lines: number;
  children?: ReactNode;
}

export const TruncateText = ({
  lines,
  children,
}: TruncateTextProps): ReactElement => {
  const [title, setTitle] = useState('');
  const callbackRef = useCallback((div: HTMLDivElement | null) => {
    setTitle(div?.textContent ?? '');
  }, []);

  return (
    <Box
      ref={callbackRef}
      display="-webkit-box"
      width="100%"
      maxHeight="100%"
      overflow="hidden"
      title={title}
      style={{
        WebkitBoxOrient: 'vertical',
        lineClamp: lines,
        WebkitLineClamp: lines,
      }}
    >
      {children}
    </Box>
  );
};
